const primaryYellow = '#FFA015';

const darkGray = '#0A0D0F';
const mediumGray = '#222A2E';
const lightGray = '#F5F2EB';
const blue = '#50BBE1';
const green = '#4FD389';
const white = '#F5F2EB';

const errorRed = '#FF7A7A';

export const colors = {
  primary: {
    yellow: primaryYellow,
    white: white,
    gray: lightGray,
    blue: blue,
    green: green,
    warning: errorRed,
    customGray: '#707D81',
  },
  background: {
    primary: darkGray,
    secondary: mediumGray,
    light: lightGray,
  },
  brand: {
    surface: '#11161A',
    surfaceAlt: '#0D1215',
    line: 'rgba(255, 255, 255, 0.08)',
    cream: '#F5F2EB',
    ink: '#0A0D0F',
    textSecondary: '#9DAAAE',
    textMuted: '#707D81',
    textStrong: '#D0D8DA',
    indigo: '#293D93',
  },
  status: {
    pending: '#F59E0B',
    running: '#50BBE1',
    concluded: '#4FD389',
    rejected: '#FF7A7A',
  },
  chart: {
    primary: '#C47A0E',
    failure: '#E06060',
    integration: '#8EA2F8',
  },
  blueTones: {
    dark: '#1e40af',
    medium: '#448be7ff',
    light: '#dbeafe',
  },
  redTones: {
    dark: '#f70000ff',
    light: '#ff4d4dff',
  },
  greenTones: {
    dark: '#00df00ff',
    light: '#44ff44ff',
  },
  runs: {
    textSecondary: '#9DAAAE',
    textMuted: '#707D81',
    textStrong: '#D0D8DA',
    surface: '#11161A',
    surfaceAlt: '#0D1215',
    amber: '#FFA015',
  },
} as const;

export const defaultInputSX = {
  marginBottom: 2,
  '& .MuiOutlinedInput-root': {
    backgroundColor: colors.background.primary,
    color: colors.primary.white,
    '& fieldset': {
      borderColor: colors.background.secondary,
    },
    '&:hover fieldset': {
      borderColor: colors.primary.yellow,
    },
    '&.Mui-focused fieldset': {
      borderColor: colors.primary.yellow,
    },
  },
  '& .MuiInputBase-input': {
    color: colors.primary.white,
  },
  '& .MuiInputLabel-root': {
    color: colors.background.secondary,
    '&.Mui-focused': {
      color: colors.primary.yellow,
    },
  },
  '& .MuiFormHelperText-root': {
    color: colors.primary.warning,
  },
} as const;

export const defaultSelectSX = {
  marginBottom: 2,
  color: colors.primary.white,
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: colors.background.secondary,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: colors.primary.yellow,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: colors.primary.yellow,
  },

  '& .MuiInputLabel-root': {
    color: colors.background.secondary,
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: colors.primary.yellow,
  },

  '& .MuiFormHelperText-root': {
    color: colors.background.secondary,
  },
  '& .MuiFormHelperText-root.Mui-focused': {
    color: colors.primary.yellow,
  },

  '& .MuiSelect-select': { color: colors.primary.white },
  '& .MuiSelect-icon': { color: colors.primary.white },
} as const;

export const defaultButtonSX = {
  color: colors.primary.yellow,
  borderColor: colors.primary.yellow,
  '&:hover': {
    backgroundColor: colors.primary.yellow,
    color: colors.background.primary,
  },
  '&:disabled': {
    color: colors.background.secondary,
    borderColor: colors.background.secondary,
  },
  fontFamily: 'inter',
  fontWeight: 500,
  padding: '12px',
} as const;
